import React from 'react';
import { Plus, Dumbbell } from 'lucide-react';
import { Program } from '../../../types/program';
import ProgramCard from './ProgramCard';

interface ProgramDirectoryProps {
  programs: Program[];
  isLoading?: boolean;
  onProgramClick: (programId: string) => void;
  onCreateNew: () => void;
}

const ProgramDirectory: React.FC<ProgramDirectoryProps> = ({
  programs,
  isLoading,
  onProgramClick,
  onCreateNew,
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="bg-[#141414] rounded-2xl border border-[#1F1F1F] overflow-hidden">
            <div className="h-60 bg-[#1F1F1F] animate-pulse" />
            <div className="p-6 space-y-3">
              <div className="h-5 bg-[#1F1F1F] rounded animate-pulse" />
              <div className="h-4 bg-[#1F1F1F] rounded animate-pulse" />
              <div className="h-4 bg-[#1F1F1F] rounded w-2/3 animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (programs.length === 0) {
    return (
      <div className="bg-[#141414] rounded-2xl border border-[#1F1F1F] flex flex-col items-center justify-center min-h-[400px] px-6 py-12">
        <Dumbbell size={64} className="text-[#5F5F5F] mb-6" />
        <h3 className="text-white text-xl font-bold mb-2">No Programs Yet</h3>
        <p className="text-[#8F8F8F] text-sm text-center max-w-md mb-6">
          Get started by creating your first workout program
        </p>
        <button
          onClick={onCreateNew}
          className="inline-flex items-center gap-2 h-11 px-6 bg-[#23F47C] text-[#0A0A0A] text-base font-semibold rounded-lg hover:bg-[#1FD66D] transition-all duration-200"
        >
          <Plus size={20} />
          <span>Create Program</span>
        </button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8">
      {programs.map((program) => (
        <ProgramCard
          key={program.id}
          program={program}
          onClick={onProgramClick}
        />
      ))}
    </div>
  );
};

export default ProgramDirectory;
